module.exports = "/_next/static/images/7c9c396daebfb0a9337c59768228c72c-2-cards@3x.jpg.webp";